import { useQuery } from '@tanstack/react-query';

import { moduleDaCaiRepository } from '../../../lib/repositories/module-da-cai.repository';
import { napManHinhModule } from '../../../lib/module-federation/nap-remote';
import type { ApiError } from '../../../lib/errors';
import type { InstalledModule } from '../types';

function thuLai(soLanDaThu: number, err: unknown): boolean {
  const status = (err as ApiError | undefined)?.status;
  if (status !== undefined && status >= 400 && status < 500) return false;
  return soLanDaThu < 1;
}

/** `bat = false` ngoài cổng tenant: endpoint đọc `tenant_id` trong token, nhân sự nền tảng không có. */
export function useModuleDaCai(bat = true) {
  return useQuery<InstalledModule[]>({
    queryKey: ['module-da-cai'],
    queryFn: moduleDaCaiRepository.danhSach,
    staleTime: 60_000,
    retry: thuLai,
    enabled: bat,
  });
}

/**
 * Component `./App` của remote. Khoá theo cả `entry`: nâng cấp module đổi URL thì nạp bản mới.
 * Không thử lại: remote hỏng hiếm khi tự lành sau một giây, người dùng có nút "Thử lại".
 */
export function useManHinhModule(code: string, entry: string | null | undefined) {
  return useQuery({
    queryKey: ['module-remote', code, entry],
    queryFn: () => napManHinhModule(code, entry as string),
    enabled: Boolean(entry),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    structuralSharing: false,
  });
}
